/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Error_Root_TitleInputs */

const en_ui_error_root_title = /** @type {(inputs: Ui_Error_Root_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault hit a snag`)
};

const de_ui_error_root_title = /** @type {(inputs: Ui_Error_Root_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault ist ins Stocken geraten`)
};

/**
* | output |
* | --- |
* | "PaceVault hit a snag" |
*
* @param {Ui_Error_Root_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_error_root_title = /** @type {((inputs?: Ui_Error_Root_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Error_Root_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_error_root_title(inputs)
	return de_ui_error_root_title(inputs)
});